import axios from 'axios'


function handleStandardResponse(response, onErrorCallback) {
	// console.log(response);

	// Uncomment to test error message:
	// onErrorCallback({error: "Something bad went wrong."}); return null;

	if(response.data) {
		if(response.data.error) {
			onErrorCallback(response.data);
			return null;
		}
		else {
			return response.data;
		}
	}
	else {
		// This will happen when the server has an error, but it's handled
		// by the Axios registered interceptor.
		return null;
	}
}

function requestOptions() {
	return {
		headers: {
			'Authorization': sessionStorage.getItem('jwt')
		}
	}
}

export default {
	init : function(apiUrl, busy) {
		this.apiUrl = apiUrl;
		this.busyState = busy;
		var self = this;
		axios.interceptors.response.use(
			function(response) {
				self.onSuccessCallback(response, self.onErrorCallback);
				return response;
			},
			function(error) {
				if(error.config.showErrors!==false) {
					self.onErrorCallback(error);
				}
				return error;
			}
		);
	},
	// Register an optional hook after each successful response.
	// Its params are the response and original path and params.
	onSuccessCallback: function(response, path, params) {
		console.log(response, path, params);
	},
	setSuccessCallback: function(callback) {
		this.onSuccessCallback = callback;
	},
	/* 
	 Register an optional hook after each response error.
	 The eror object is: { error: 'error message', error_fr: 'french error message'}	
	 */
	onErrorCallback: function(error){
		// this is meant to be overwritten - console to slience lint
		console.log('onErrorCallback',error);
	},
	setErrorCallback: function(callback) {
		this.onErrorCallback = callback;
	},
	busy: function(){
		if(this.busyState) {
			this.busyState.busy();
		}
	},
	notBusy: function() {
		if(this.busyState) {
			this.busyState.notBusy();
		}
	},
	serverStatus: function() {
		var self = this;
		return axios.get(this.apiUrl + '/status', {}, requestOptions())
		.then(function(response) {
			return response.data;
		}).catch(function(error){
			console.log('serverStatus catch',error)
			self.onErrorCallback(error);
		});
	},
	doPostWithJwt: function(path, params, showBusy) {
		var self = this;
		if(showBusy) {
			self.busy();
		}
		return axios.post(this.apiUrl + path, params, requestOptions())
			.then(function(response){
				return handleStandardResponse(response, self.onErrorCallback);
			}).finally(function(){
				if(showBusy) {
					self.notBusy();
				}
			}
		);
	},


	/*
		Gets all the latest reports the user can see.
		Optionally pass in a dealerCode for users that can see
		dealer codes.
	 */
	getDefaultSet: function(dealerCode) {
		var params = {};
		if(dealerCode) {
			params.dealerCode = dealerCode;
		}
		return this.doPostWithJwt('/usersreports', params, true);
	},
	getDealerCodes: function() {
		return this.doPostWithJwt('/dealercodes', {}, true);
	},
	search: function(keyPair) {
		return this.doPostWithJwt('/search', keyPair, true);
	},
	getSearchCriteria: function() {
		return this.doPostWithJwt('/searchcriteria', {}, true);
	},
	download: function(id) {
		return this.doPostWithJwt('/download', {id:id}, true);
	},

	// filename is optional
	downloadCombined: function(ids, filename) {
		return this.doPostWithJwt('/download_combined', {ids:ids, filename: filename}, true);
	},

	markReadUnread : function(ids, isMarkRead) {
		return this.doPostWithJwt('/mark_read_unread', {ids, isMarkRead}, true);
	},
	getUserInfo: function() {
		return this.doPostWithJwt('/user/info', {}, false);
	},

	// Returns user admin data (users, roles, etc)
	getUserAdminData: function() {
		return this.doPostWithJwt('/user/adminrecords', {}, true);
	},
	// Returns user admin data (users, roles, etc)
	getUserUserDetailsForAdmin: function(id) {
		return this.doPostWithJwt('/user/user_details_for_admin', {id:id}, true);
	},
	updateUserInfo: function(user) {
		return this.doPostWithJwt('/user/update', user, true);
	},
	createUser: function(user) {
		return this.doPostWithJwt('/user/create', user, true);
	},
	createReport: function(report) {
		return this.doPostWithJwt('/user/reportcreate', report, true);
	},
	updateReportInfo: function(report) {
		return this.doPostWithJwt('/user/reportupdate', report, true);
	},
	updateRetention: function(reportsToUpdate) {
		return this.doPostWithJwt('/user/retentionupdate', reportsToUpdate, true);
	},
	// Calls the server to logout.
	// This is a bit different than the other endpoint because it 
	// calls on the same domain as the app, not the api, and we 
	// ignore any errors.
	serverLogout: function() {
		var self=this;
		self.busy();
		return axios({
				url: 'user/logout',
				method: 'GET',
				responseType: 'json',
				showErrors: false
			}).then(function(response) {
				return response.data;
			}).catch(function(){
				// We don't care if this has an error.
			}).finally(function(){
				self.notBusy();
			}
		);
	}

}